import { render, staticRenderFns } from "./FactureDetailOld.vue?vue&type=template&id=5fdf65e8&scoped=true&"
import script from "./FactureDetailOld.vue?vue&type=script&lang=js&"
export * from "./FactureDetailOld.vue?vue&type=script&lang=js&"
import style0 from "./FactureDetailOld.vue?vue&type=style&index=0&id=5fdf65e8&lang=scss&scoped=true&"
import style1 from "./FactureDetailOld.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./FactureDetailOld.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdf65e8",
  null
  
)

export default component.exports